// Simple profiling logger.
//
// For parity work we want a quiet console + minimal overhead by default.
// Enable explicitly via:
// - window.__FG_PROFILER = true
// - or URL param `?fg_profiler=1`
const enabled = (() => {
  if (typeof window === 'undefined') return false
  const w = window as any
  if (w.__FG_PROFILER === true) return true
  try {
    const sp = new URLSearchParams(window.location.search)
    const profiler = String(sp.get('fg_profiler') || '').trim().toLowerCase()
    if (profiler === '1' || profiler === 'true' || profiler === 'yes' || profiler === 'on') return true
  } catch {
    // ignore
  }
  return false
})()

const ACTUAL_DURATION_THRESHOLD_MS = 8
const BASE_DURATION_THRESHOLD_MS = 40
const LOG_INTERVAL_MS = 750
let lastLogAtMs = -Infinity
let suppressedSinceLastLog = 0

export function logRender(
  id: string,
  phase: 'mount' | 'update' | 'nested-update',
  actualDuration: number,
  baseDuration: number,
  startTime: number,
  commitTime: number,
) {
  if (!enabled) return

  // Keep mount visibility, but suppress low-signal update noise.
  if (
    phase !== 'mount' &&
    actualDuration < ACTUAL_DURATION_THRESHOLD_MS &&
    baseDuration < BASE_DURATION_THRESHOLD_MS
  ) {
    suppressedSinceLastLog += 1
    return
  }

  // Rate-limit profiler output to avoid log storms dominating main thread.
  if (commitTime - lastLogAtMs < LOG_INTERVAL_MS) {
    suppressedSinceLastLog += 1
    return
  }
  lastLogAtMs = commitTime

  const suppressed = suppressedSinceLastLog
  suppressedSinceLastLog = 0
  try {
    // eslint-disable-next-line no-console
    console.log('[FG-RENDER-BUDGET]', JSON.stringify({
      id,
      phase,
      actual_ms: Number(actualDuration.toFixed(1)),
      base_ms: Number(baseDuration.toFixed(1)),
      start_ms: Number(startTime.toFixed(1)),
      commit_ms: Number(commitTime.toFixed(1)),
      suppressed_since_last: suppressed,
    }))
  } catch {
    // eslint-disable-next-line no-console
    console.log(
      `[FG-RENDER-BUDGET] id=${id} phase=${phase} actual=${actualDuration.toFixed(1)}ms ` +
      `base=${baseDuration.toFixed(1)}ms start=${startTime.toFixed(1)} commit=${commitTime.toFixed(1)}` +
      (suppressed > 0 ? ` suppressed=${suppressed}` : '')
    )
  }
}

